import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
export const Group = styled.div `
  display: flex;
  > * {
    flex: 0 0 calc(${({ columns }) => (columns ? `100%/${columns}` : '100%')});
    &:not(:first-child) {
      border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
    }
  }
`;
export const LineItem = styled.p `
  word-break: break-all;
  &:not(:last-child) {
    margin: 0 0 3px;
  }
  &:last-child {
    margin: 0;
  }
`;
export const Wrapper = styled.div `
  padding: 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
export const Title = styled.p `
  color: ${({ theme }) => theme.colors.grey100_1};
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 14px;
  font-weight: normal;
`;
export const Text = styled.div `
  font-size: 13px;
  margin: 0;
  color: ${({ theme }) => theme.colors.black_1};
  padding: 0;
  word-break: break-all;
  ${({ isFormattedText }) => isFormattedText &&
    css `
      font-style: italic;
      white-space: pre-wrap;
    `}
`;
export const Pre = styled(Text).attrs(() => ({
    as: 'pre',
})) `
  white-space: pre-wrap;
  word-break: break-word;
  background: transparent;
  border: none;
  font-family: inherit;
  overflow: hidden;
`;
const Note = ({ dataTestId, title, text, pre, isFormattedText = true }) => (_jsxs(Wrapper, { "data-testid": dataTestId, children: [title && _jsx(Title, { children: title }), text && _jsx(Text, { isFormattedText: isFormattedText, children: text }), pre && _jsx(Pre, { children: pre })] }));
const NoteMemo = React.memo(Note);
const NoteWrapper = Object.assign(NoteMemo, {
    Group,
    LineItem,
});
export default NoteWrapper;
